type Config<T = unknown> = {
    default: T;
} & Record<string, T>;

/**
 *
 * @param config @type Object
 * @returns function which returns value by path
 */
export const makeConfig = <T, K extends string>(config: Config<T>) =>
    (path: K) => config[path] ?? config.default;
